module.exports = __webpack_public_path__ + "media/images/icons/filled/filter-f9f9ab9db698d29b32e2482c7f876b2d.svg";